import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DividendForecastingModule } from '@app/eclipse/dividend-forecasting/dividend-forecasting.module';
import { AgGridModule } from 'ag-grid-angular';
import { ToastrModule } from "ngx-toastr";
import { BreadcrumbComponent, BreadcrumbItemDirective } from 'xng-breadcrumb';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { DocumentationModule } from './documentation/documentation.module';
import { PortalModule } from './portal/portal.module';
import { ScbModule } from './scb/scb.module';
import { MarkitSharedModule } from './shared/shared.module';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import javascript from 'highlight.js/lib/languages/javascript';
import scss from 'highlight.js/lib/languages/scss';
import typescript from 'highlight.js/lib/languages/typescript';
import xml from 'highlight.js/lib/languages/xml';
import { HIGHLIGHT_OPTIONS, HighlightModule } from 'ngx-highlightjs';
import { NgxPageScrollCoreModule } from 'ngx-page-scroll-core';
import { providePrimeNG } from 'primeng/config';
import { EtpModule } from './etp/etp.module';
import { spBrandThemePreset } from './theme.preset';

export function hljsLanguages() {
  return [
    { name: 'typescript', func: typescript },
    { name: 'javascript', func: javascript },
    { name: 'scss', func: scss },
    { name: 'xml', func: xml }
  ];
}

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent],
    exports: [],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        CoreModule.forRoot(),
        ToastrModule.forRoot({
            timeOut: 10000,
            positionClass: 'toast-top-right',
            progressBar: true,
            preventDuplicates: true,
        }),
        PortalModule,
        MarkitSharedModule,
        ScbModule,
        DividendForecastingModule,
        EtpModule,
        DocumentationModule,
        HighlightModule,
        AgGridModule,
        BreadcrumbComponent,
        BreadcrumbItemDirective,
        NgxPageScrollCoreModule.forRoot({ duration: 1600 })], providers: [
        {
            provide: HIGHLIGHT_OPTIONS,
            useValue: {
                languages: hljsLanguages()
            }
        },
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({ theme: { preset: spBrandThemePreset, options: { darkModeSelector: 'none' } } })
    ]
})
export class AppModule { }
